var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('h4',{staticClass:"text-center"},[_vm._v("Informatii utile")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }